<div class="fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center z-40">
  <div class="fixed top-0 right-0 bottom-0 left-0 bg-backdrop" (click)="hide()"></div>
  <div class="bg-white rounded-lg p-4 m-4 pb-10 w-96 shadow-md z-10 relative">
    <div class="w-full flex justify-end mb-2">
      <svg
        data-testid="toast-cross-icon"
        class="hover:bg-gray-10 rounded-lg cursor-pointer"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="hide()"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.4571 4.54289C19.8476 4.93342 19.8476 5.56658 19.4571 5.95711L5.95711 19.4571C5.56658 19.8476 4.93342 19.8476 4.54289 19.4571C4.15237 19.0666 4.15237 18.4334 4.54289 18.0429L18.0429 4.54289C18.4334 4.15237 19.0666 4.15237 19.4571 4.54289Z"
          fill="#0B0B0B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.54289 4.54289C4.93342 4.15237 5.56658 4.15237 5.95711 4.54289L19.4571 18.0429C19.8476 18.4334 19.8476 19.0666 19.4571 19.4571C19.0666 19.8476 18.4334 19.8476 18.0429 19.4571L4.54289 5.95711C4.15237 5.56658 4.15237 4.93342 4.54289 4.54289Z"
          fill="#0B0B0B"
        />
      </svg>
    </div>
    <div class="flex flex-col gap-2 items-center">
      @if (type() === 'error') {
        <svg
          data-testid="toast-error-icon"
          class="mb-2"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.056 16.4711C11.8636 16.4711 11.6756 16.5282 11.5156 16.6351C11.3556 16.742 11.2309 16.8939 11.1573 17.0716C11.0837 17.2494 11.0644 17.445 11.1019 17.6337C11.1395 17.8224 11.2321 17.9957 11.3682 18.1318C11.5042 18.2678 11.6776 18.3605 11.8663 18.398C12.055 18.4356 12.2506 18.4163 12.4283 18.3427C12.6061 18.269 12.758 18.1443 12.8649 17.9844C12.9718 17.8244 13.0288 17.6363 13.0288 17.4439C13.0288 17.1859 12.9263 16.9385 12.7439 16.7561C12.5615 16.5736 12.314 16.4711 12.056 16.4711Z"
            fill="#DB1212"
          />
          <path
            d="M12.056 14.5255V6.5"
            stroke="#DB1212"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
            stroke="#DB1212"
            stroke-width="2"
            stroke-miterlimit="10"
          />
        </svg>
      }
      <h1 data-testid="toast-title" class="text-heading-05 md:text-heading-04 text-gray-90">
        {{ title() }}
      </h1>
      <p
        data-testid="toast-description"
        class="text-body-02 md:text-body-01 text-center text-gray-90 max-w-72 whitespace-break-spaces"
      >
        {{ description() }}
      </p>
    </div>
  </div>
</div>
